
import {throwError as observableThrowError,  Observable ,  Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpWrapperService } from './http-wrapper.service';
import { environment } from '../../environments/environment';
import { apiConstant } from '../../app/app-constant';

@Injectable()

export class UserService {

  _apiHost: string;
  _nodeName: string;
  _nodeType: string;
  _userName: string;
  public userDataSub = new Subject<string>();
  _peers: any;
  _displayName: string;
  _lastLogin: any;
  _hsbcNetUrl: string;

  constructor(private httpWrapperService: HttpWrapperService) { }

  get apiHost() {
    if(!this._apiHost) {
      this._apiHost = localStorage.getItem('apiHost');
    }
	  return this._apiHost;
  }

  set apiHost(val: string) {
    localStorage.setItem('apiHost', val);
    this._apiHost = val;
  }
  
  get nodeName() {
    if(!this._nodeName) {
      this._nodeName = localStorage.getItem('nodeName');
    }
	  return this._nodeName;
  }

  set nodeName(val: string) {
    localStorage.setItem('nodeName', val);
    this._nodeName = val;
  }

  get nodeType() {
    if(!this._nodeType) {
      this._nodeType = localStorage.getItem('nodeType');
    }
	  return this._nodeType;
  }

  set nodeType(val: string) {
    localStorage.setItem('nodeType', val);
    this._nodeType = val;
  }

  get userName() {
    if(!this._userName) {
      this._userName = localStorage.getItem('userName');
    }
	  return this._userName;
  }

  set userName(val: string) {
    
    localStorage.setItem('userName', val);
    this._userName = val;
  }

  /* get peers() {
    if(!this._peers) {
      //this.getPeers();
    }
	  return this._peers;
  }

  set peers(val: string) {
    this._peers = val;
  } */

  get displayName() {
    if(!this._displayName) {
      this._displayName = localStorage.getItem('displayName');
    }
	  return this._displayName;
  }

  set displayName(val: string) {
    localStorage.setItem('displayName', val);
    this._displayName = val;
  }

  get lastLogin() {
    if(!this._lastLogin) {
      this._lastLogin = localStorage.getItem('lastLogin');
    }
	  return this._lastLogin;
  }

  set lastLogin(val: string) {
    localStorage.setItem('lastLogin', val);
    this._lastLogin = val;
  }

  get hsbcNetUrl() {
    if(!this._hsbcNetUrl) {
      this._hsbcNetUrl = this.getCookie('hsbcneturl');
    }
	  return this._hsbcNetUrl;
  }

  set hsbcNetUrl(val: string) {
    this._hsbcNetUrl = val;
  }

  getUserData(): Observable<any> {
    let that = this;
    return this.httpWrapperService.get(this._apiHost + apiConstant.ME)
                .map(function(res: any) {
                  let data = res || {};
                  that._nodeName = data.me.organisation;
                  localStorage.setItem('nodeName', data.me.organisation);
                  that._nodeType = data.me.organisationUnit;
                  localStorage.setItem('nodeType', data.me.organisationUnit);
                  that.userDataSub.next('Y');
                  return data;
                })
                .catch(function(err) {
                  return observableThrowError(err.message || err);
                });
  }

  getCustAuditor(): Observable<any> {
    return this.httpWrapperService.get(this._apiHost + apiConstant.CUST_AUDITOR)
                .map(function(res: any) {
                  return res || {};
                })
                .catch(function(err) {
                  return observableThrowError(err.message || err);
                });
  }

  assignAuditor(data): Observable<any> {
    return this.httpWrapperService.post(this._apiHost + apiConstant.ASSIGN_AUDITOR, data)
                .map(function(res: any) {
                  //return res._body;//typeof res._body == "string" ? res : (res || {});
                  return res || {};
                })
                .catch(function(err) {
                  return observableThrowError(err.message || err);
                });
  }

  updateAuditor(data): Observable<any> {
    return this.httpWrapperService.post(this._apiHost + apiConstant.UPDATE_AUDITOR, data)
                .map(function(res: any) {
                  //return res._body;
                  return res || {};
                })
                .catch(function(err) {
                  return observableThrowError(err.message || err);
                });
  }

  getPeers(): Observable<any> {
    return this.httpWrapperService.get(this._apiHost + apiConstant.PEERS)
                .map(function(res: any) {
                  let peers = res.peers;
                  this._peers = peers;
                  return peers;
                })
                .catch(function(err) {
                  return observableThrowError(err.message || err);
                });
  }

  getCookie(name: string) {
    let ca: Array<string> = document.cookie.split(';');
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
        c = ca[i].replace(/^\s+/g, '');
        if (c.indexOf(cookieName) == 0) {
            return c.substring(cookieName.length, c.length);
        }
    }
    return '';
  }

  deleteCookie(name: string) {
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

  getApiVersion(): Observable<any> {
    return this.httpWrapperService.get(this._apiHost + apiConstant.API_VERSION, null, false, true, true)
                .map(function(res: any) {
                  return res;
                })
                .catch(function(err) {
                  return observableThrowError(err.message || err);
                });
  }

  getApiCordaVersion(): Observable<any> {
    return this.httpWrapperService.get(this._apiHost + apiConstant.API_CORDA_VERSION)
                .map(function(res: any) {
                  return res;
                })
                .catch(function(err) {
                  return observableThrowError(err.message || err);
                });
  }
}
